import { ArtistWidget } from '../../ArtistWidget/types';
import { FaqWidget } from './Faq';
import { AgendaWidget } from './NewAgenda/types';
import { Widget, WidgetType } from './types';

type ParsedWidgets = Partial<
    Record<WidgetType, AgendaWidget | FaqWidget | ArtistWidget>
>;

export function parseWidgets(widgets: Widget[]) {
    const transformedWidgets: ParsedWidgets = {};

    widgets.forEach((widget) => {
        transformedWidgets[widget.type] = widget.data;
    });

    return transformedWidgets;
}
